module.exports = __webpack_public_path__ + "img/343-ac08da.png";